import React from "react";

// POST /player/withdraw deducts the balance immediately, so the player
// confirms the amount and destination before it is sent.
export default function WithdrawConfirmPopup({
  amount,
  destination,
  onConfirm,
  onCancel,
}) {
  return (
    <div
      className="modal fade otp--modal mpin-setup-prompt show"
      style={{
        display: "block",
        backdropFilter: "blur(15px)",
        background: "rgb(70, 70, 70, 0.6)",
      }}
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0">
            <span className="modal-title fs-5" />
            <i
              aria-label="Close"
              className="bi bi-x-lg"
              onClick={onCancel}
            />
          </div>
          <div className="modal-body mpin-setup-prompt__body text-center">
            <p className="mpin-setup-prompt__subtitle">Confirm withdrawal</p>
            <p className="mpin-setup-prompt__title">
              Withdraw ₹{amount} to {destination}?
            </p>
            <p className="text--medium low-opacity mb-4">
              The amount is deducted from your balance now and paid out once
              approved.
            </p>
            <div className="mpin-setup-prompt__actions">
              <button
                type="button"
                className="mpin-setup-prompt__no-btn"
                onClick={onCancel}
              >
                Cancel
              </button>
              <button
                type="button"
                className="mpin-setup-prompt__yes-btn"
                onClick={onConfirm}
              >
                Withdraw
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
